import ProductTags from ".";

export const productTagsRoutes = () => [
  {
    path: "/admin/products-tags",
    component: ProductTags,
    layout: "admin",
    routeType: "admin",
    title: "Products Management",
  },
];
